import background2 from '../assets/images/background2.png';
import buildingBackground from '../assets/images/building/buildingBackground.png';
import firstFloorFront from '../assets/images/building/firstFloorFront.png';
import firstFloorSide from '../assets/images/building/firstFloorSide.png';
import roofTopFront from '../assets/images/building/roofTopFront.png';
import secondFloorFront from '../assets/images/building/secondFloorFront.png';
import secondFloorSide from '../assets/images/building/secondFloorSide.png';
import thirdFloorFront from '../assets/images/building/thirdFloorFront.png';
import thirdFloorSide from '../assets/images/building/thirdFloorSide.png';
import logo from '../assets/images/logo.png';
import scenario2 from '../assets/images/scenario2.png';

export const imagePaths = {
  background2,
  buildingBackground,
  firstFloorFront,
  firstFloorSide,
  roofTopFront,
  secondFloorFront,
  secondFloorSide,
  thirdFloorFront,
  thirdFloorSide,
  logo,
  scenario2,
};

export const initialTime = 150;
